<template>
  <v-app-bar :color="isManagementURL() ? `managementNavbar` : `navbar`" dark app>
    <v-row>
      <v-col cols="3" class="d-flex justify-center without-padding-left">
        <v-toolbar-title>
          <router-link to="/">
            <v-img
              :src="require('../../assets/xici.svg')"
              class="my-3 d-none d-md-block"
              contain
              height="50"
            />
            <v-img
              :src="require('../../assets/xici-mini.svg')"
              class="my-3 d-block d-md-none"
              contain
              height="50"
            />
          </router-link>
        </v-toolbar-title>
      </v-col>
      <v-col cols="3" />
      <v-spacer />
      <v-spacer />
      <v-spacer />
      <v-col
        cols="4"
        class="d-flex justify-end align-center without-padding-right"
      >
        <v-btn v-if="isAdmin" text class="d-none d-md-flex" :to="'/manage/edit'" small>
          <v-icon>mdi-database</v-icon>
          {{ $t("section.directEdit") }}
        </v-btn>
        <v-btn v-if="isAdmin" text class="d-none d-md-flex" :to="'/manage/forms'" small>
          <v-badge
            :content="pendingValidateForms"
            :value="pendingValidateForms"
            color="yellow darken-2"
            overlap
            left
          >
            <v-icon left>mdi-clipboard-text</v-icon>
          </v-badge>
          {{ $t("section.manageForms") }}
        </v-btn>
        <v-divider
          v-if="isAdmin"
          class="mx-4 d-none d-md-block"
          vertical
        ></v-divider>
        <v-menu offset-y open-on-hover>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-if="isAdmin" icon v-bind="attrs" v-on="on" text class="d-md-none">
              <v-badge
                :content="pendingValidateForms"
                :value="pendingValidateForms"
                color="yellow darken-2"
                dark
                overlap
                left
              >
                <v-icon>mdi-account-hard-hat</v-icon>
              </v-badge>
            </v-btn>
          </template>
          <v-list>
            <v-list-item v-if="isAdmin" link to="/manage/forms">
              <v-badge
                :content="pendingValidateForms"
                :value="pendingValidateForms"
                color="yellow darken-2"
                overlap
                left
              >
                <v-icon left>mdi-clipboard-text</v-icon>
              </v-badge>
              {{ $t("section.manageForms") }}
            </v-list-item>
            <v-list-item v-if="isAdmin" to="/manage/edit">
              <v-icon left>mdi-database</v-icon>
              {{ $t("section.directEdit") }}
            </v-list-item>
          </v-list>
        </v-menu>
        <NotificationsMenu v-if="isAuthenticated && isInternal" />
        <v-btn v-if="isAuthenticated" icon @click="userSignOut" text>
          <v-icon>mdi-logout-variant</v-icon>
        </v-btn>
        <v-btn v-else icon to="/login" text>
          <v-icon>mdi-login-variant</v-icon>
        </v-btn>
      </v-col>
      <v-col class="without-padding-left" />
    </v-row>
  </v-app-bar>
</template>

<script>
import NotificationsMenu from "./NotificationsMenu";
import axios from "axios";
export default {
  components: { NotificationsMenu },
  data: () => ({
    supervisor_polling: null,
    pendingValidateForms: 0
  }),
  mounted() {
    if (this.isAdmin) {
      this.getPendingFormsSupervisorNumber();
      this.pollSupervisorData();
    }
  },

  beforeDestroy() {
    clearInterval(this.supervisor_polling);
  },

  methods: {
    isManagementURL() {
      if(this.$route.path.includes("manage/") || this.$route.path.includes("direction/") ) return true;
      else return false;
    },
    pollSupervisorData() {
      this.supervisor_polling = setInterval(() => {
        this.getPendingFormsSupervisorNumber();
      }, 60000);
    },
    onMenuItemClick(item) {
      if (item.action) {
        item.action();
      }
    },
    userSignOut() {
      this.$store.dispatch("logout").then(() => {
        this.$i18n.locale = "en";
        this.$store.dispatch("setLanguage", "en");
        this.$router.push("/login");
      });
    },
    getPendingFormsSupervisorNumber() {
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/review/pending/moderator";
      axios
        .get(path)
        .then(response => {
          this.pendingValidateForms = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
